<template>
  <div class="dashboard-page">
    <Header @show-sidebar="sidebar.show = true"/>
    <div class="container">
      <Split v-model="panel.raito">
        <div slot="left" class="left-panel">
          <SubjectPanel />
        </div>
        <div slot="right" class="right-panel">
          <MaterialPanel />
        </div>
      </Split>
    </div>
    <Drawer
      width="160"
      :styles="{padding: 0}"
      :closable="false"
      placement="left"
      v-model="sidebar.show">
      <Sidebar @hide-sidebar="sidebar.show = false"/>
    </Drawer>
    <SubjectAcceptModal />
    <JournalEditModal />
    <SubjectQueryModal />
    <ChannelMessageModal />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Header from '../components/dashboard/Header.vue'
import Sidebar from '../components/dashboard/Sidebar.vue'
import SubjectPanel from '../components/dashboard/SubjectPanel.vue'
import SubjectAcceptModal from '../components/dashboard/SubjectAcceptModal.vue'
import SubjectQueryModal from '../components/dashboard/SubjectQueryModal.vue'
import JournalEditModal from '../components/dashboard/JournalEditModal.vue'
import MaterialPanel from '../components/dashboard/MaterialPanel.vue'
import ChannelMessageModal from '../components/dashboard/ChannelMessageModal.vue'

export default {
  components: {
    Header,
    Sidebar,
    SubjectPanel,
    SubjectAcceptModal,
    JournalEditModal,
    SubjectQueryModal,
    MaterialPanel,
    ChannelMessageModal,
  },
  data () {
    return {
      sidebar: {show: false},
      panel: {raito: 0.48},
    }
  },
  computed: {
    ...mapGetters({
      workspace: 'dashboard/workspace'
    })
  },
  methods: {
    ...mapActions({
      loadCredentials: 'loadCredentials',
      loadChannel: 'loadChannel',
      loadWorkspace: 'dashboard/loadWorkspace',
      unloadWorkspace: 'dashboard/unloadWorkspace',
    }),
    initialize() {
      this.loadWorkspace(this.$route.params)
    },
    finalize() {
      this.unloadWorkspace(this.$route.params)
    },
    reset() {
      this.finalize()
      this.initialize()
    },
  },
  watch: {
    '$route': 'reset'
  },
  async mounted() {
    await this.loadCredentials()
    await this.loadChannel()
    await this.initialize()
  },
  destroyed() {
    this.finalize()
  }
}
</script>

<style lang="less">
html, body {
  height: 100%;
}
</style>

<style lang="less" scoped>
.dashboard-page {
  height: 100%;

  .container {
    width: 100%;
    height: 100%;
    padding-top: 46px;

    .left-panel {
      height: 100%;
      overflow-x: hidden;
    }

    .right-panel {
      padding-left: 6px;
      overflow-x: hidden;
      height: 100%;
    }
  }
}
</style>
